import { render, staticRenderFns } from "./SecondAgentComp.vue?vue&type=template&id=59c3b948&scoped=true&"
import script from "./SecondAgentComp.vue?vue&type=script&lang=js&"
export * from "./SecondAgentComp.vue?vue&type=script&lang=js&"
import style0 from "./SecondAgentComp.vue?vue&type=style&index=0&id=59c3b948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c3b948",
  null
  
)

export default component.exports